module.exports = __webpack_public_path__ + "media/components/assets/bottle_icon_01-6fa445a2c74481a05cebddac60941c9a.png";